module.exports = {
  url: 'https://authenticate.beta.api.unoapp.io',
  business_url: 'https://accounts.beta.api.unoapp.io',
  authorization_url: 'https://authorize.beta.api.unoapp.io',
  giftcard_url: 'https://giftcards.beta.api.unoapp.io',
  app_id: '0mtzdEQPGN4a83DW4lPpcTuQkp8B9sbQ',
  app_secret: '0KhzYVho4OJwYeagWmY9oQyX8Itdhg0L',
  resource_url: 'https://resources.beta.api.unoapp.io',
};
